import React from 'react';
import { ISetupData } from '../models';
import { Link, Stack, Text } from 'library/ui';

interface IMicroDepositFormProps {
    setupData: ISetupData;
}

function SetupIntentInfo({ setupData }: IMicroDepositFormProps) {
    return (
        <Stack gap="sm" align="start" padding="md">
            <Text>
                <b>Est. Arrival Date:</b> {setupData.arrival_date}
            </Text>
            <Link href={setupData.verification_url}>Verify Link</Link>
        </Stack>
    );
}

export default SetupIntentInfo;
